const config = {
  rowSelection: false,
  columns: [
    {
      title: '订单号',
      dataIndex: 'orderNo',
      width: 160,
      ellipsis: true,
    },
    {
      title: '收款计划',
      dataIndex: 'planMainName',
      width: 140,
      ellipsis: true,
    },
    {
      title: '报价确认时间',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      width: 160,
    },
    {
      title: '报价类型',
      dataIndex: 'quotationTypeName',
      ellipsis: true,
      width: 100,
    },
    {
      title: '状态',
      dataIndex: 'stateName',
      width: 100,
    },
    {
      title: '异常信息',
      dataIndex: 'errInfo',
      render: 'operateTooltip',
      width: 460,
      // ellipsis: true,
    },
    {
      title: '修改人',
      dataIndex: 'modifiedByName',
      width: 100,
      ellipsis: true,
    },
    {
      title: '修改日期',
      dataIndex: 'lastUpdatedTime',
      itemType: 'dateTime',
      width: 160,
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 240,
      render: 'renderOperate',
      fixed: 'right'
    },
  ],
  search: [
    {
      name: 'orderNo',
      label: '订单号',
      placeholder: '订单号',
    },
    {
      name: 'state',
      label: '状态',
      itemType: 'select',
      key: "key",
      labelKey: "description",
      data: 'errStateList'
    }
  ],
  searchInitialValues: {
    'state': 'handler_pending'
  },
  footer: []
}
export default config
